import { useEffect, useState } from "react";
import { Card, Button, Space, Form, message } from "antd";
import { useParams } from "react-router-dom";
import HostForm from "./components/HostForm";
import { getHostDetail, updateHost } from "../api/host";

export default function HostDetail() {
  const { id } = useParams();
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [editing, setEditing] = useState(false);

  useEffect(() => {
    console.log("idchange,resetfileds");
    form.resetFields();
    if (id) {
      fetchDetail();
    }
  }, [id]);

  const fetchDetail = async () => {
    setLoading(true);
    const res = await getHostDetail(id);
    console.log("res.data", res.data);
    form.setFieldsValue(res.data);
    // form.setFieldsValue(res.data);
    setLoading(false);
  };

  const handleSave = async () => {
    const values = await form.validateFields();
    await updateHost(id, values);
    message.success("保存成功");
    // form.resetFields();
    setEditing(false);
    // fetchDetail();
  };

  return (
    <Card
      loading={loading}
      title="房源详情"
      extra={
        <Space>
          {editing ? (
            <>
              <Button
                onClick={() => {
                  setEditing(false);
                }}
              >
                取消
              </Button>
              <Button type="primary" onClick={handleSave}>
                保存
              </Button>
            </>
          ) : (
            <Button type="primary" onClick={() => setEditing(true)}>
              编辑
            </Button>
          )}
        </Space>
      }
    >
      <HostForm form={form} disabled={!editing} />
    </Card>
  );
}
